export enum UserFilterType {
    StudyCenterClient = 1,
    Partner = 2,
    CommonUser = 3,
}
